import "./App.css";
import Vehicles from "./components/Vehicles";
import makes from "./data/vehicle_makes";
import models from "./data/vehicle_models";
import colors from "./data/vehicle_color";
import years from "./data/vehicle_year";
import sgnumbers from "./data/sg_numbers";
import golf_cart_colors from "./data/vehicle_golf_cart_color";

window.$makes = makes;
window.$models = models;
window.$colors = colors;
window.$years = years;
window.$units = sgnumbers;
window.$golf_cart_colors = golf_cart_colors;

function App() {
  return (
    <div className="App">
      <Vehicles />
    </div>
  );
}

export default App;
